import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const rolesList = {
  admin: {
    name: "administrator",
    route: "/beheerder",
  },
  requestor: {
    name: "requestor",
    route: "/verzoeken",
  },
  substitutor: {
    name: "substitutor",
    route: "/home",
  },
  coordinator: {
    name: "coordinator",
    route: "/verzoeken/overzicht",
  },
  support: {
    name: "support",
    route: "/support/gebruikers",
  },
  documentbeheer: {
    name: "documentbeheer",
    route: "/documentbeheer",
  },
  // Soft menu role only — never used as primary login redirect.
  afas: {
    name: "afas",
    route: "/afas/openstaand",
  },
};
// find data for current role
// example: return {name: "administrator", route: "/beheerder"}
export const getCurrentRole = (roles) => {
  let roleEntries;

  if (roles.includes("administrator")) {
    roleEntries = Object.entries(rolesList).find(
      ([key, value]) => value.name === "administrator"
    );
  } else {
    const primaryRole = (roles || []).find((role) => role && role !== "afas");
    roleEntries = Object.entries(rolesList).find(
      ([key, value]) => value.name == primaryRole
    );
  }
  return roleEntries ? roleEntries[1] : <Navigate to="/no-access" />;
};


const HasPermission = ({ children, showFor, hideFor, showError }) => {
  const [hasPermission, setHasPermission] = useState(true);
  const userRoles = useSelector((state) => state.UserPermission);
  const checkRoles = (roles) => {

    if (!userRoles?.roles) {
      return false;
    }
    const rolesArray = Array.isArray(roles) ? roles : [roles];
    if (userRoles.roles.includes("administrator") && roles === "administrator") {
      return true;
    }
    if (!userRoles.roles.includes("administrator")) {
      const result = rolesArray.some((role) =>
        userRoles.roles.includes(role)
      );
      return result;
    }
    return false;
  };

useEffect(() => {

  if (showFor) {
    const result = checkRoles(showFor);
    setHasPermission(result);
  } else if (hideFor) {
    const result = !checkRoles(hideFor);
    setHasPermission(result);
  }
}, [showFor, hideFor]); // added userRoles for better debugging



  return hasPermission ? (
    <>
      {children}
    </>
  ) : (
    <>
      {showError && <Navigate to="/no-access" replace />}
    </>
  );
};


export default HasPermission;
